import { render, staticRenderFns } from "./calchis.vue?vue&type=template&id=25c7141f&scoped=true"
import script from "./calchis.vue?vue&type=script&lang=js"
export * from "./calchis.vue?vue&type=script&lang=js"
import style0 from "./calchis.vue?vue&type=style&index=0&id=25c7141f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c7141f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
